import styled from "styled-components";
import dotsBg from "../../../assets/images/dots-bg.png";

export const EmailModalStyled = styled.div`
  width: 100%;
  height: calc(100vh - 100px);
  position: relative;
  background: var(--white);
  padding: 50px;

  .connect-email-content-holder {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .form-area {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .head {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0 0 20px;

    .icon-holder {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      border-radius: 50px;
      background: var(--blue);
      color: var(--white);
      cursor: pointer;
    }

    .title {
      font-size: 16px;
      line-height: 20px;
      font-weight: 600;
      color: var(--primary);
    }
  }

  .content-holder {
    min-height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    overflow: hidden;

    .sc-fpSrms {
      margin: 0 0 24px;
    }

    .checkbox-holder {
      width: max-content;
    }

    .title {
      display: block;
      font-size: 16px;
      line-height: 20px;
      font-weight: 400;
      margin: 0 0 10px;
      color: var(--primary);
    }

    .custom-provider-holder,
    .options-wrapper,
    .google-provider-holder,
    .outlook-provider-holder {
      width: 100%;
      max-width: 850px;
    }

    .options-wrapper {
      width: 100%;
      padding: 20px;
      border-radius: 20px;
      border: 1px solid #efefef;

      .title {
        display: block;
        font-size: 20px;
        line-height: 24px;
        font-weight: 600;
        color: var(--primary);
        margin: 0 0 5px;
      }

      .sub-heading {
        display: block;
        margin: 0 0 25px;
      }

      .tabBtn {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 15px;
        padding: 20px;
        border-radius: 10px;
        overflow: hidden;

        &:not(:last-child) {
          margin: 0 0 15px;
        }

        &.active {
          border: 1px solid rgba(49, 123, 255, 0.1);
          background: rgba(49, 123, 255, 0.1);

          .ico-tick {
            border: 1.5px solid var(--blue);

            &::before {
              display: block;
            }
          }
        }
      }

      .icon-box {
        width: 40px;
        height: 40px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .text-box {
        border-left: 1px solid #efefef;
        padding: 0 0 0 15px;
        text-align: start;

        .subtitle {
          display: block;
          font-size: 14px;
          line-height: 18px;
          color: rgba(49, 49, 49, 0.5);
        }

        .title {
          display: block;
          font-size: 16px;
          line-height: 20px;
          font-weight: 700;
          margin: 0;
        }
      }

      &.bulk-email-table {
        .table-head,
        .table-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .table-head {
          font-weight: 500;
          color: var(--text-color-50);
          padding: 35px 35px 25px;
          border-bottom: 1px solid var(--gray-250);
          margin: 0 -20px 0;
        }

        .table-body {
          padding: 0 5px;
          height: calc(100vh - 530px);
          overflow-y: auto;
          margin: 20px 15px;

          .table-row {
            margin: 0 0 20px;
          }
        }
      }

      .protocols-holder {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 0 30px;
      }
    }

    .verification-holder {
      padding: 60px;
      text-align: center;

      .img-holder {
        width: 100%;
        max-width: 150px;
        margin: 0 auto 30px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      p {
        margin: 0 0 20px;
      }

      a {
        color: var(--blue);
      }

      .btn-holder {
        display: flex;
        align-items: center;
        gap: 20px;

        .resend-email-btn {
          font-size: 16px;
          line-height: 20px;
          font-weight: 500;
          color: var(--light-gray);
        }
      }
    }

    .outlook-provider-holder {
      .heading {
        display: block;
        font-size: 18px;
        line-height: 22px;
        font-weight: 600;
        color: var(--text-color-50);
        margin: 0 0 30px;
      }

      .col {
        width: 100% !important;
        display: flex;
        justify-content: space-between !important;
        gap: 30px;
        font-size: 18px;
        line-height: 22px;
        color: var(--text-color-50) !important;
        background: #fcfcfc !important;

        .icon {
          flex-shrink: 0;
        }
      }

      .bold {
        font-weight: 700 !important;
      }
    }
    a {
      text-decoration: underline;
    }

    .google-provider-holder,
    .outlook-provider-holder {
      .google-provider-head {
        display: flex;
        align-items: center;
        gap: 20px;
        padding: 0 0 20px;
        border-bottom: 1px solid var(--gray-250);
        margin: 0 0 30px;

        .header-content {
          padding: 0 0 0 20px;
          border-left: 1px solid var(--gray-250);
        }
      }
      .col-holder {
        display: flex;
        gap: 25px;
        border-radius: 15px;
        overflow: hidden;

        .col {
          width: 50%;
          padding: 25px 20px;
          cursor: pointer;
          background: #fcfcfc;
          color: var(--text-color-50);
          transition: 0.3s;

        

          .col-head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0 0 20px;
            .heading {
              display: block;
              font-size: 18px;
              line-height: 22px;
              font-weight: 500;
              margin: 0 0 5px;
            }
            .text,
            .recommended-tag {
              display: block;
              font-size: 14px;
              line-height: 18px;
            }
            .recommended-tag {
              background: var(--blue);
              color: var(--white);
              padding: 5px 10px;
              border-radius: 5px;
            }
          }

          ul {
            padding: 0 0 0 10px;
            li {
              font-weight: 300;
              display: flex;
              align-items: center;
              gap: 5px;
              color: var(--gray-300);
              &:not(:last-child) {
                margin: 0 0 12px;
              }
              .icon {
                color: var(--blue);
              }
            }
          }

          &:hover {
            background: var(--blue);
            color: var(--white);
            .recommended-tag {
              background: var(--white);
              color: var(--blue);
            }
            li {
              color: var(--white);
              .icon {
                color: var(--white);
              }
            }
          }
        }
      }

      .bold {
        font-weight: 500;
        color: var(--blue);
      }
    }

    .oauth-holder {
      .head {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;


      }

      ol {
        padding: 0 0 0 20px;
        margin: 0 0 30px;

        li {
          &:not(:last-child) {
            margin: 0 0 12px;
          }

          &::marker {
            color: var(--black);
          }

          .client-id-holder {
            display: flex;
            align-items: center;
            gap: 10px;
            justify-content: space-between;
            background: #fcfcfc;
            border-radius: 10px;
            padding: 10px;
            margin: 10px 0 0;

            span {
              font-size: 14px;
              line-height: 18px;
              color: var(--text-color-50);
            }
            button {
              padding: 5px 18px;
              color: var(--white);
              background: var(--blue);
              border-radius: 5px;
            }
          }
        }
      }
      &.app-password-holder {
        ol {
          margin: 0 0 12px;
        }
      }

      .select-other {
        display: block;
        font-size: 14px;
        line-height: 18px;
        font-weight: 700;
        font-style: italic;
        margin: 0 0 20px 20px;
      }
    }

    .app-password-label {
      display: block;
      color: var(--text-color-50);
      margin: 0 0 10px;
    }

    .app-password-note {
      display: block;
      color: #b8b8b8;
      margin: 0 0 10px;
    }

    .csv-file-holder {
      width: 100%;

      form {
        > div {
          margin: 0 0 25px;
        }
      }
    }

    .download-sample-btn-holder {
      display: flex;
      justify-content: flex-end;
      margin: 0 0 10px;
    }
  }

  .select-another-provider-holder {
    width: max-content;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    gap: 3px;
    color: var(--light-gray);
    border: 1px solid var(--gray-100);
    border-radius: 20px;
    padding: 4px 8px;
    cursor: pointer;
    transition: 0.3s;
    margin: 0 0 20px 40px;

    &:hover {
      color: var(--blue);
      border-color: var(--blue);
    }
  }

  .middle-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    min-height: 290px;
    max-width: 560px;
    margin: 0 auto;
    text-align: center;
    color: #9d9d9d;
    &.success {
      flex-direction: column;
    }

    .img-box {
      display: block;
      width: 70px;
      margin: 0 auto 20px;
    }

    .title {
      display: block;
      font-size: 25px;
      line-height: 28px;
      font-weight: 500;
      text-transform: capitalize;
      color: #313131;
      margin: 0 0 10px;
    }
  }

  .info-text {
    display: block;
    font-size: 13px;
    line-height: 16px;
    a {
      color: var(--blue);
    }
  }

  .input-flex {
    display: flex;
    gap: 15px;

    &.margin {
      margin: 0 0 25px;
    }

    .flex-item {
      width: 100%;
      position: relative;

      .note {
        position: absolute;
        bottom: -5px;
        left: 0;
        font-size: 12px;
        line-height: 16px;
      }
    }
  }

  .input-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    padding: 20px;
    margin: 0 0 20px;
    border-radius: 10px;
    background: rgba(202, 202, 202, 0.05);

    .text-box {
      width: 100%;
      max-width: 400px;
      font-size: 13px;
      line-height: 16px;
      font-weight: 300;
      color: #9d9d9d;

      .title {
        display: block;
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        margin: 0 0 6px;
        color: #313131;
      }
    }

    .input-box {
      width: 100%;
      max-width: 275px;

      .sc-fpSrms {
        margin: 0;
      }

      .input {
        border-radius: 10px;
      }
    }

    .enable-disable-tabs {
      width: 100%;
      max-width: 275px;

      button {
        font-size: 12px;
        line-height: 16px;
        font-weight: 300;
        padding: 14px 20px;
        border: 1px solid #efefef;
        border-radius: 10px 0 0 10px;
        transition: 0.3;

        &:nth-child(2) {
          border-radius: 0 10px 10px 0;
        }

        &.active {
          color: var(--white);
          border-color: var(--blue);
          background: var(--blue);
        }
      }
    }
  }

  .public-key-holder {
    position: relative;

    .field-holder {
      margin: 0 0 20px;
    }

    .label {
      display: block;
      font-size: 16px;
      line-height: 20px;
      margin: 0 0 5px;
      color: #313131;
    }

    .input-box {
      position: relative;
      width: 100%;
      min-height: 42px;
      font-size: 14px;
      line-height: 18px;
      padding: 15px 95px 15px 15px;
      border-radius: 10px;
      word-break: break-all;
      border: 1px solid #e0e0e0;
      background: #fafafa;

      .btn-copy {
        min-width: 78px;
        cursor: pointer;
        position: absolute;
        top: 5px;
        right: 5px;
        padding: 3px 5px;
        font-size: 14px;
        line-height: 17px;
        text-transform: capitalize;
        color: var(--blue);
        text-align: center;
        border-radius: 8px;
        border: 1px solid var(--blue);
        background: #ebf0f9;
        &:hover {
          background: var(--white);
        }
      }
    }
  }

  .btn-holder {
    display: flex;
    justify-content: center;
  }

  .custom-provider-holder {
    width: 100%;
    position: relative;

    .close-icon-holder {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 12px;
      line-height: 14px;
      display: flex;
      align-items: center;
      gap: 5px;
      z-index: 1;
      color: var(--danger);
      user-select: none;
    }
    .close-icon {
      cursor: pointer;
    }
  }

  .table-footer {
    position: absolute;
    left: 0;

    &::before {
      display: none;
    }
  }
`;

export const StepsContainer = styled.div`
  width: 100%;
  max-width: 800px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto 45px;
`;

export const StepItem = styled.div``;

export const StepCircle = styled.div`
  position: relative;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  background-color: ${({ $isActive }) =>
    $isActive ? "var(--blue)" : "var(--gray-150)"};
  color: ${({ $isActive }) => ($isActive ? "white" : "var(--light-gray)")};
  margin: 0 auto 15px;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    background-color: var(--white);
  }
`;

export const StepLabel = styled.span`
  color: ${({ $isActive }) =>
    $isActive ? "var(--secondary)" : "var(--light-gray)"};
  font-weight: ${({ $isCurrent }) => ($isCurrent ? 600 : 400)};
`;

export const StepConnector = styled.div`
  position: absolute;
  top: 50%;
  left: 20px;
  width: ${({ $width }) => $width && $width};
  height: 2px;
  transform: translateY(-50%);
  background-color: ${({ $isActive }) =>
    $isActive ? "var(--blue)" : "var(--gray-150)"};
`;

export const StyledConnectDomainModal = styled.div`
  width: 100%;
  position: relative;
  padding: 0 0 70px;
  background: var(--white);

  .form-area {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .step-list {
    display: flex;
    align-items: center;
    list-style: none;
    margin: -25px -25px 0;
    padding: 0;
    font-size: 16px;
    line-height: 20px;
    text-transform: capitalize;
    color: #7f8594;
    text-align: center;

    li {
      flex-grow: 1;
      padding: 18px 15px;
      position: relative;
      border-bottom: 2px solid #e6e7ec;

      &.active,
      &:hover {
        color: var(--blue);
        font-weight: 600;
        border-color: var(--blue);
        background: #e9f3fd;
      }
    }
  }

  .content-holder {
    flex-grow: 1;
    min-height: 300px;
    padding: 30px 10px 40px;

    .sc-fpSrms {
      margin: 0 0 24px;
    }

    .checkbox-holder {
      width: max-content;
    }
  }

  .middle-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 350px;
    max-width: 560px;
    margin: 0 auto;
    text-align: center;
    color: #9d9d9d;

    .img-box {
      display: block;
      width: 70px;
      margin: 0 auto 20px;
    }

    .title {
      display: block;
      font-size: 25px;
      line-height: 28px;
      font-weight: 500;
      text-transform: capitalize;
      color: #313131;
      margin: 0 0 10px;
    }
  }

  .heading-holder {
    margin: 0 0 24px;
  }

  .info-text {
    display: block;
    font-size: 13px;
    line-height: 16px;
    a {
      color: var(--blue);
    }
  }

  .input-flex {
    display: flex;
    gap: 15px;
  }

  .input-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    padding: 20px;
    margin: 0 0 20px;
    border-radius: 10px;
    background: rgba(202, 202, 202, 0.05);

    .text-box {
      width: 100%;
      max-width: 400px;
      font-size: 13px;
      line-height: 16px;
      font-weight: 300;
      color: #9d9d9d;

      .title {
        display: block;
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        margin: 0 0 6px;
        color: #313131;
      }
    }

    .input-box {
      width: 100%;
      max-width: 275px;

      .sc-fpSrms {
        margin: 0;
      }

      .input {
        border-radius: 10px;
      }
    }

    .enable-disable-tabs {
      width: 100%;
      max-width: 275px;

      button {
        font-size: 12px;
        line-height: 16px;
        font-weight: 300;
        padding: 14px 20px;
        border: 1px solid #efefef;
        border-radius: 10px 0 0 10px;
        transition: 0.3;

        &:nth-child(2) {
          border-radius: 0 10px 10px 0;
        }

        &.active {
          color: var(--white);
          border-color: var(--blue);
          background: var(--blue);
        }
      }
    }
  }

  .public-key-holder {
    position: relative;

    .field-holder {
      margin: 0 0 20px;
    }

    .label {
      display: block;
      font-size: 16px;
      line-height: 20px;
      margin: 0 0 5px;
      color: #313131;
    }

    .input-box {
      position: relative;
      width: 100%;
      min-height: 42px;
      font-size: 14px;
      line-height: 18px;
      padding: 15px 95px 15px 15px;
      border-radius: 10px;
      word-break: break-all;
      border: 1px solid #e0e0e0;
      background: #fafafa;

      .btn-copy {
        min-width: 78px;
        cursor: pointer;
        position: absolute;
        top: 5px;
        right: 5px;
        padding: 3px 5px;
        font-size: 14px;
        line-height: 17px;
        text-transform: capitalize;
        color: var(--blue);
        text-align: center;
        border-radius: 8px;
        border: 1px solid var(--blue);
        background: #ebf0f9;
        &:hover {
          background: var(--white);
        }
      }
    }
  }

  .btn-holder {
    position: absolute;
    bottom: -24px;
    left: -24px;
    right: -24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 15px 20px;
    border-top: 1px solid #e6e7ec;

    &::before {
      display: none;
      content: "";
      position: absolute;
      bottom: 100%;
      left: 0;
      right: 0;
      height: 50px;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        #f4f4f4 100%
      );
    }

    .btn-wrap {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-grow: 1;
      gap: 10px;
    }

    /* button {
      border-radius: 10px;
    } */
  }
`;

export const DomainModalStyled = styled.div`
  width: 100%;
`;
